var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlumbob(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "88px",
    height: "188px",
    viewBox: "0 0 88 188",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Plumbob") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "current",
    strokeWidth: 1,
    fill: "current",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Plumbob"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44,4.71764754 L84.8555692,92 L3.14443077,92 L44,4.71764754 Z",
    id: "Triangle",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44,98.7176475 L84.8555692,186 L3.14443077,186 L44,98.7176475 Z",
    id: "Triangle",
    strokeWidth: 4,
    transform: "translate(44.000000, 141.000000) scale(1, -1) translate(-44.000000, -141.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44,8.77637701 L63.4778692,92 L24.5221308,92 L44,8.77637701 Z",
    id: "Triangle",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44,102.776377 L63.4778692,186 L24.5221308,186 L44,102.776377 Z",
    id: "Triangle",
    strokeWidth: 4,
    transform: "translate(44.000000, 141.000000) scale(1, -1) translate(-44.000000, -141.000000) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1.5,
    y1: 93.5,
    x2: 86.5,
    y2: 93.5,
    id: "Line",
    strokeLinecap: "square"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlumbob);
export default __webpack_public_path__ + "static/media/plumbob.964ef0d399fb9c850871fec114cb440d.svg";
export { ForwardRef as ReactComponent };